import LJAppUsageTable from "root/s360components/Tables/LJAppUsageTable";
import {Fragment, useEffect, useState} from "react";
import {getAppUsageCountsForLea} from "root/DataFunctions/LJAppUsageFns";
import SpinnerDiv from "ui/ReactSpinnerDiv";

const EMPTY_DATA = {data: [], isLoading: true}
const LJAppUsageManager = ({leaId, userType, hideUnused}) =>
{
    const [data, setData] = useState(EMPTY_DATA);

    const filtersExists = leaId !== null && userType !== null && leaId !== undefined && userType !== undefined;

    //Filtered client side so toggling doesn't refetch. Counts can arrive from PDO as strings, hence the +
    const tableData = hideUnused === true
        ? data.data.filter(row => +row.distinct_users > 0 || +row.total_usages > 0)
        : data.data;

    const getData = () =>
    {
        getAppUsageCountsForLea(leaId, userType, (response) =>
        {
            setData({data: response.results.record_set, isLoading: false})
        })
    }

    useEffect(() =>
    {
        if (filtersExists === true)
        {
            setData(EMPTY_DATA);

            getData();
        }
    }, [leaId, userType])


    const noParamsSelectedSection = () =>
    {
        return (
            <div key='k1'
                 style={{margin: "20px", marginTop: "150px", marginBottom: "150px", textAlign: "center"}}>
                <h4 key='please'>Please select both filters</h4>
            </div>
        )
    }

    const loadingSection = () =>
    {
        return (
            <div className='spinner-with-margin' key={'k2'}>
                <SpinnerDiv/>
            </div>
        )
    }


    return (
        <Fragment key='k3'>
            {(filtersExists === true && data.isLoading === false) && <LJAppUsageTable data={tableData}/>}
            {(filtersExists === true && data.isLoading === true) && loadingSection()}

            {filtersExists === false && noParamsSelectedSection()}
        </Fragment>
    )
}

export default LJAppUsageManager;
